import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Modal } from 'react-bootstrap';
import { FaFilter, FaPen, FaPlus, FaSearch, FaSyncAlt, FaTrash } from 'react-icons/fa';
import { API_URL_All } from '../../api';
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import { CheckingTicket, FeedbackChecking } from '../tickets/Tickets';
import axiosInstance from '../../axiosInstance';

const MultiOrderEditor = ({ data, handleSearch }) => {
  const [show, setShow] = useState(true);
  const [isLocked, setIsLocked] = useState(true);
  const [model, setModel] = useState({});
  const [customerCode, setCustomerCode] = useState('');

  useEffect(() => {
    fetchOneRecord(data.id);
  }, [data]);

  const setSizeItem = async (name, e) => {
    var value = e.target.value;
    const newModel = { ...model };
    if (name === 'packageUnitM3') {
      newModel.sizeX = 0;
      newModel.sizeY = 0;
      newModel.sizeZ = 0;
    }

    newModel[name] = value;
    setModel(newModel);
  }


  const addOrderProduct = () => {
    var obj = { ...model };
    var details = obj.details;
    if (!details || details.length === 0) {
      obj.details = [{}];
    } else {
      obj.details.push({});
    }

    setModel(obj);
  };


  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    setShow(false);
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    var dataModel = { ...model };

    try {
      var updateOrderApi = `/api/import-orders/saveMultiOrders`;
      const response = await axiosInstance.post(updateOrderApi, dataModel);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (handleSearch) handleSearch();
      handleModalClose();
    } catch (error) {
      toast.error(error.message);
    }

  };

  const fetchOneRecord = async (orderId) => {
    document.querySelectorAll('.error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    const isNumber = Number.isFinite(orderId);
    if (!isNumber) {
      orderId = 0;
    }
    setModel({});
    try {
      var urlApi = `/api/import-orders/getOrder?id=${orderId}`;
      const response = await axiosInstance.get(urlApi);
      var obj = response.data.data;
      if (!obj.details) obj.details = [{}];
      var checkSize = obj.sizeX + obj.sizeY + obj.sizeZ;
      obj.size3 = (checkSize > 0);
      if (obj.details) {
        obj.details.forEach((item, index) => {
          var checkSize = item.sizeX + item.sizeY + item.sizeZ;
          item.size3 = (checkSize > 0);
        });
      }

      if (!obj.id && data.isDraft) obj.isDraft = true;

      setModel(obj);
      setIsLocked(response.data.data.locked);
      setCustomerCode(response.data.data.customerCode);
      setShow(true);
    } catch (error) {
      console.error(error);
      setIsLocked(true);
      setModel({error: error.message});
      toast.error(error.message);
    }
  };


  const setDetailsItem = async (index, name, e) => {
    var value = e.target.value;
    if (value === 'on') value = e.target.checked;
    const newDetails = [...model.details];
    var item = newDetails[index];
    if (name === 'price') {
      item.money = item.quantity * value;
    }
    if (name === 'priceIn') {
      item.moneyIn = item.quantity * value
    }
    if (name === 'quantity') {
      item.money = value * item.price;
      item.moneyIn = value * item.priceIn;
    }
    if (name === 'size') {
      item.sizeX = '';
      item.sizeY = '';
      item.sizeZ = '';
    }
    if (name === 'productName') {
      var thTag = e.target.closest('.th');
      if (thTag) {
        var selecteTag = thTag.querySelector('.item_selected');
        if (selecteTag && selecteTag.innerText === value && value) {
          setIsLocked(true);
          try {
            var urlApi = `/api/products/getProductDetail?name=${value}`;
            const response = await axiosInstance.get(urlApi);

            var obj = response.data.data;
            obj.productId = obj.id;
            obj.productCode = obj.code;
            delete obj.id;
            obj.quantity = 1;
            obj.packageCount = 1;
            obj.money = obj.priceDeclare;

            var checkSize = obj.sizeX + obj.sizeY + obj.sizeZ;
            obj.size3 = (checkSize > 0);

            obj.providerName = obj.bestProviderName;
            obj.productLink = obj.bestProductLink;

            Object.assign(item, obj);
            console.log(item);
          } catch (error) {
            console.error(error);
            toast.error(error.message);
          }
          setIsLocked(false);
        }
      }

    }
    if (name === 'providerName') {
      var thTag = e.target.closest('.th');
      if (thTag) {
        var selecteTag = thTag.querySelector('.item_selected');
        if (selecteTag && selecteTag.innerText === value && value) {
          setIsLocked(true);
          try {
            const params = {
              refer: value,
              referId: item.productId,
            };
            const response = await axiosInstance.get(`/api/providers/getProductProviderByName`,{ params });

            var obj = response.data.data;
            console.log(obj);
            //item.priceIn = obj.price;
            item.productLink = obj.productLink;
          } catch (error) {
            console.error(error);
            toast.error(error.message);
          }
          setIsLocked(false);
        }
      }

    }
    item[name] = value;
    setModel({ ...model, details: newDetails });
    //updateWarningMessage({ ...model, details: newDetails });
  }

  return (
    <Modal show={show} onHide={handleModalClose} size="xl">
      <div className="modal-dialog11 modal-lg11">
        <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleSubmitForm}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.orderCode && (<span className="record_id">Code: {model.orderCode}</span>)}
              <div>
                <h5 className="modal-title">Tạo nhiều đơn hàng</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body mt-2">
              <div className="group-box p-0" data-text="Thông tin chung">
                <div className="group-body">

                  <div className="row">
                    <div className="col-md-2 mb-3">
                      <label className="form-label required">Line</label>
                      <div className="th filter-editor">
                        <span className="filter-ib" data-source-key="editor_lines">
                          <input type="text" name="line" placeholder="Nhập line" data-required="Phải nhập mục này." disabled={isLocked} value={model.lineName ?? ''} onChange={(e) => setModel({ ...model, lineName: e.target.value })} />
                        </span>
                      </div>
                    </div>
                    {model.isAdmin && (
                      <div className="col-md-2 mb-3">
                        <div>
                          <label className="form-label required">Mã khách hàng</label>
                          <div className="th filter-editor">
                            <span className="filter-ib" data-source-url={API_URL_All + '/api/users/searchUserCodes'}>
                              <input type="text" name="customerCode" placeholder="Nhập mã khách hàng..." data-required="Phải nhập mục này." disabled={model.locked || isLocked} value={model.customerCode ?? ''} onChange={(e) => setModel({ ...model, customerCode: e.target.value })} />
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    {model.isAdmin && (
                      <div className="col-md-2 mb-3">
                        <label className="form-label">Lưu trình</label>
                        <div className="th filter-editor">
                          <span className="filter-ib" data-source-key="list_status">
                            <input type="text" name="line" placeholder="Nhập lưu trình" disabled={model.locked || isLocked || model.isDraft} value={model.statusName ?? ''} onChange={(e) => setModel({ ...model, statusName: e.target.value })} />
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="col-md-1 mb-3">
                      <label className="form-label">&nbsp;</label>
                      <div>
                        <CheckingTicket checkingId={model.statusRateId} checkingName={model.statusRateName} />
                      </div>
                    </div>

                  </div>



                  <div className="row">
                    <div className="col-md-12 mb-3 pe-0">
                      <label className="form-label">Phương thức lấy hàng</label>
                      <div className="th filter-editor">
                        <span className="filter-ib" data-source-url={API_URL_All + '/api/import-orders/searchAddress'}><input type="text" placeholder="Nhập địa chỉ..." disabled={isLocked} data-refer={model.customerCode} value={model.shippingMethod ?? ''} onChange={(e) => setModel({ ...model, shippingMethod: e.target.value })} /></span>
                      </div>
                    </div>
                  </div>


                  {!model.isAdmin && (
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label className="form-label">Lưu trình: </label>
                        <span className="select3-item ms-3">{model.statusName ?? ''}</span>
                      </div>
                    </div>
                  )}
                </div>

              </div>
              <div className="group-box p-0  pb-2" data-text={`Danh sách đơn hàng`}>

                  <div className="group-body">

                  <div className="row">
                    <div className=" col-md-2 p-0">
                      <label className="form-label" data-note="">Mã vận đơn TQ</label>
                    </div>
                      <div className="col-md-3 p-0">
                        <label className="form-label required">Tên đơn hàng/sản phẩm</label>
                    </div>
                    <div className="col-md-1 p-0">
                      <label className="form-label" data-note="">Số kiện</label>
                    </div>
                    <div className="col-md-1 p-0">
                      <label className="form-label" data-note="kg">K.lượng</label>
                    </div>
                    <div className="col-md-1 p-0">
                      <label className="form-label" data-note="m3">Thể tích</label>
                    </div>
                    <div className="col-md-1 p-0">
                      <label className="form-label" data-note="">Giá trị b.hiểm</label>
                    </div>

                      <div className="col-md-1 p-0 d-none">
                        <label className="form-label" data-note="vnđ">Phụ phí</label>
                    </div>

                      <div className="col-md-1 p-0 d-none">
                        <label className="form-label" data-note="vnđ">Thành tiền</label>
                      </div>
                      <div className="col-md-3 p-0">
                        <label className="form-label">Ghi chú</label>
                      </div>
                    </div>

                  {model.details && model.details.map((item, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-2 p-0">
                        <div className="">
                          <input type="text" className="form-control" placeholder="..." disabled={isLocked} value={item.cnCode ?? ''} onChange={(e) => setDetailsItem(index, 'cnCode', e)} />
                        </div>
                      </div>
                      <div className="col-md-3 p-0">
                        <div className="th filter-editor">
                          <span className="filter-ib" data-source-url={API_URL_All + '/api/products/searchProductNamesByCustomerAndProvider'}>
                            <input type="text" disabled={isLocked} data-refer={`${model.customerCode}---${model.providerName}`} placeholder="..." data-required="Phải nhập mục này." name="name" value={item.productName ?? ''} onChange={(e) => setDetailsItem(index, 'productName', e)} />
                          </span>
                        </div>
                      </div>
                      <div className="col-md-1 p-0">
                        <div className="">
                          <input type="number" className="form-control" placeholder="..." disabled={isLocked} value={item.packageCount ?? ''} onChange={(e) => setDetailsItem(index, 'packageCount', e)} />
                        </div>
                      </div>
                      <div className="col-md-1 p-0">
                        <div className="">
                          <input type="number" className="form-control" placeholder="..." disabled={isLocked} value={item.weight ?? ''} onChange={(e) => setDetailsItem(index, 'weight', e)} />
                        </div>
                      </div>
                      <div className="col-md-1 p-0">
                        <div className="">
                          <input type="number" className="form-control" placeholder="..." disabled={isLocked} value={item.size ?? ''} onChange={(e) => setDetailsItem(index, 'size', e)} />
                        </div>
                      </div>
                      <div className="col-md-1 p-0">
                        <div className="">
                          <input type="number" className="form-control" placeholder="..." disabled={isLocked} value={item.priceInsurance ?? ''} onChange={(e) => setDetailsItem(index, 'priceInsurance', e)} />
                        </div>
                      </div>
                      <div className="col-md-1 p-0 d-none">
                        <div className="">
                          <input type="number" className="form-control" placeholder="Phụ phí" disabled={isLocked} value={item.feeSurcharge ?? ''} onChange={(e) => setDetailsItem(index, 'feeSurcharge', e)} />
                        </div>
                      </div>
                      <div className="col-md-1 p-0 d-none">
                        <div className="">
                          <input type="text" className="form-control form-price" placeholder="Thành tiền" disabled={true} value={general.formatNumber(item.money)} />
                        </div>
                      </div>
                      {!model.isAdmin && (
                        <div className="col-md-3 p-0">
                          <div className="">
                            <input type="text" className="form-control" placeholder="Ghi chú" disabled={item.locking || item.locked || model.locked || isLocked} value={item.noteUser ?? ''} onChange={(e) => setDetailsItem(index, 'noteUser', e)} />
                          </div>
                        </div>
                      )}
                      {model.isAdmin && (
                        <div className="col-md-3 p-0">
                          <div className="">
                            <input type="text" className="form-control" placeholder="Ghi chú" disabled={item.locking || item.locked || model.locked || isLocked} value={item.noteAdmin ?? ''} onChange={(e) => setDetailsItem(index, 'noteAdmin', e)} />
                          </div>
                        </div>
                      )}
                    </div>


                  ))}
                  </div>

                </div>
              <button type="button" className="small-btn" onClick={addOrderProduct}><FaPlus /></button>

            </div>
            <div className="modal-footer justify-content-between">
              <div>
              </div>
              <button type="submit" className="btn-sm btn btn-primary">Lưu nhiều đơn</button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default MultiOrderEditor;
